<template>
    <div id="panel-4" class="panel">
        <div class="panel-hdr ">
            <h2>
                {{__t('LIST')}} <span class="fw-300"><i>{{__t('ROLES')}}</i></span>
            </h2>

            <div class="panel-toolbar">
                <b-overlay :show="is_load">
                    <button class="btn btn-icon btn-sm btn-success mr-1 shadow-0 waves-effect waves-themed" v-on:click="create">
                        <i class="fal fa-plus"></i>
                    </button>
                </b-overlay>


                <button class="btn btn-panel waves-effect waves-themed"
                        data-action="panel-fullscreen"
                        data-toggle="tooltip" data-offset="0,10" data-original-title="Fullscreen">
                </button>
            </div>
        </div>

        <div class="panel-container show">
            <div class="panel-content">
                <b-row>
                    <b-col :cols="12" :md="4" :lg="4" :xl="4"
                           v-for="item in rows" :key="'role_' + item.id">
                        <div class="role-card card shadow-xs mb-4">
                            <!-- header -->
                            <div class="card-header d-flex align-items-center">
                                <div class="role-avatar mr-3 ">

                                    <span class="icon-stack fs-xxl" v-if="!is_tg(item)">
                                        <i class="base-2 icon-stack-3x color-primary-400"></i>
                                        <i class="base-10 text-white icon-stack-1x"></i>
                                        <i class="ni md-profile color-primary-800 icon-stack-2x"></i>
                                    </span>

                                    <span class="icon-stack fs-xxl" v-else>
                                        <i class="base-2 icon-stack-3x color-info-400"></i>
                                    </span>
                                </div>

                                <div class="flex-fill">
                                    <div class="d-flex align-items-center">
                                        <div class="role-title text-truncate">{{ item.title }}</div>
                                    </div>
                                </div>

                                <div class="ml-auto d-flex align-items-center">
                                    <!-- toggle -->
                                    <div class="custom-control custom-switch mr-2" v-if="!is_tg(item)">
                                        <input :id="'role-switch-' + item.id"
                                               type="checkbox"
                                               class="custom-control-input"
                                               :checked="item.published"
                                               @change="toggleActive(item)">
                                        <label class="custom-control-label" :for="'role-switch-' + item.id"></label>
                                    </div>

                                    <!-- kebab -->
                                    <b-dropdown right size="sm" variant="light" no-caret toggle-class="btn-icon btn-light border-0">
                                        <template #button-content>
                                            <i class="fal fa-ellipsis-v"></i>
                                        </template>
                                        <b-dropdown-item @click="edit(item)">
                                            <i class="fal fa-pen mr-2"></i>{{__t('EDIT')}}
                                        </b-dropdown-item>
                                        <b-dropdown-divider/>
                                        <b-dropdown-item class="text-danger" @click="remove(item)"><i class="fal fa-trash-alt mr-2"></i>{{__t('REMOVE')}}</b-dropdown-item>
                                    </b-dropdown>
                                </div>
                            </div>

                            <!-- body -->
                            <div class="card-body">
                                <!-- zones -->
                                <div class="text-muted small mb-2 font-weight-600">
                                    {{__t('LOCAIONS_COUNT')}}
                                </div>
                                <div class="zones-wrap mb-3">
                                  <span class="badge zone-pill" v-if="item.locations_ids.length">
                                    {{ item.locations_ids.length }}
                                  </span>
                                    <span v-else class="text-muted small">
                                        {{__t('ALL')}}
                                    </span>
                                </div>

                                <!-- code block -->
                                <div class="text-muted small mb-2 font-weight-600">
                                    {{__t('PIN')}}
                                </div>
                                <div class="code-row d-flex align-items-center">
                                    <div class="code-box flex-fill">{{ item.pin || '—' }}</div>
                                </div>
                            </div>

                            <!-- footer buttons -->
                            <div class="card-footer d-flex justify-content-between" v-if="show_copy(item)">
                                <button class="btn btn-sm btn-warning d-flex align-items-center" @click="copyCode(item)">
                                    <i class="fal fa-copy mr-2"></i> {{__t('COPY_CODE')}}
                                </button>

                                <!--
                                <button class="btn btn-sm btn-outline-success d-flex align-items-center" @click="open_bot(item)">
                                    <i class="fal fa-copy mr-2"></i> {{__t('ATTACH_TG')}}
                                </button>
                                -->

                                <button class="btn btn-sm btn-outline-success d-flex align-items-center" @click="open(item)" v-if="show_open_url(item)">
                                    <i class="fal fa-copy mr-2"></i> {{__t('OPEN_URL')}}
                                </button>
                            </div>
                        </div>
                    </b-col>
                </b-row>
                <div class="row">

                </div>
            </div>
        </div>

        <role_modal @remove="remove"></role_modal>
    </div>
</template>


<script>
import Role_modal from "../row/role_modal.vue";

export default {
    name: "base_role",
    components: {Role_modal},

    props : {
        provider: {
            type : Object,
        }
    },


    data() {
        return {
            rows : [],

            pagination: {
                total: 0,
                limit: 50,
                pagesCurrent: 1
            },

            list: {
                direction: "DESC",
                ordering: "id",
                start: 0
            },

            filter: {
                search: "",
                groups: [],
            },


            is_load:true,

            cur_records:35,
            active_items : [],
            defaultLogo: 'https://api.getorder.biz/img/lg.svg'
        }
    },

    mounted() {
        this.load_items();
    },

    created() {
        EventBus.$on('reload_roles',this.load_items);

    },

    methods : {

        show_copy(item) {
            return !this.is_tg(item);
        },

        show_open_url(item) {
            return !this.is_tg(item);
        },


        is_tg(item) {
            return item.type == 'tg:bot';
        },

        async load_items() {
            this.rows = [];
            this.is_load = true;

            await api.post('/internal/v1/roles/' + this.provider.id + "/access", {
                list: this.list,
                filter: this.filter
            }).then(({data}) => {
                this.is_load = false;
                if (data.status === "operation_success") {
                    this.rows = data.data;

                    if (data.message?.pagination) {
                        this.pagination = data.message.pagination;
                    }
                }

            }).catch(({response}) => {
                this.is_load = false;
                EventBus.$emit('show_toast', {
                    err: response.data.message,
                    type: "danger",
                    title: response.data.status
                });
            });
        },

        edit(item) {
            console.log('edit_item',item);
            EventBus.$emit('role_edit', item.id, this.provider.id);
        },


        create() {
            console.log(this.provider);
            EventBus.$emit('role_edit',0,this.provider.id);
        },

        async toggleActive(item) {
            const newVal = !item.published;
            const keep = item.published;
            item.active = newVal; // опт. UI
            try {
                await api.post(`/internal/v1/roles/${this.provider.id}/access/${item.id}/status`, { state: newVal ? true : false });
            } catch (e) {
                item.active = keep; // откат
                EventBus.$emit('show_toast', {
                    err: response.data.message,
                    type: "danger",
                    title: response.data.status
                });
            }
        },

        async remove(item) {
            const is_ok = confirm_me(this.__t("ARE_SURE"));
            is_ok.then(res => {

                let url = `/internal/v1/roles/${this.provider.id}/access/`+ parseInt(item.id);

                if(this.is_tg(item)) {
                    url = '/internal/v1/roles/' + this.provider.id + '/telegram/' + item.origin_id;
                }

                this.is_load = true;
                api.delete(url).then(({data}) => {
                    this.is_load = false;
                    if (data.status === "operation_success") {
                        this.load_items();
                    }
                }).catch(({response}) => {
                    self.is_load = false;
                    EventBus.$emit('show_toast', {
                        err: response.data.message, type: "danger",
                        title: response.data.status,
                        position : "b-toaster-top-left"
                    })
                });
            });
        },

        copyCode(item) {
            const code = item.access_code || '';
            if (!code) return;
            navigator.clipboard?.writeText(code).then(() => {
                EventBus.$emit('show_toast', { err: 'Скопійовано', type: 'success', title: 'OK' });
            }).catch(() => {
                // fallback
                const ta = document.createElement('textarea');
                ta.value = code; document.body.appendChild(ta); ta.select();
                try { document.execCommand('copy'); } finally { document.body.removeChild(ta); }
                EventBus.$emit('show_toast', { err: 'Скопійовано', type: 'success', title: 'OK' });
            });
        },

        open(item) {
            let url = "/roles/"+ this.provider.type +"/" + item.pin + "/" + item.client_id + "/attach";
            window.open(url);
        },

    }
}
</script>


<style scoped>
/* карточка */
.role-card {
    border: 1px solid #e9ecef;
    border-radius: 14px;
    overflow: hidden;
    background: #fff;
}
.role-card:hover {

}
.card-header {
    background: #fff;
    border-bottom: 1px solid #f1f3f5;
    padding: .9rem 1rem;
}
.card-footer {
    background: #fff;
    border-top: 1px solid #f1f3f5;
    padding: .75rem 1rem;
}

/* заголовок/аватар */
.role-logo {
    width: 40px;
    height: 40px;
    object-fit: cover;
}
.role-title {
    font-weight: 600;
    font-size: 1rem;
}

/* зоны — как pill */
.zones-wrap {
    display: flex;
    flex-wrap: wrap;
    gap: .4rem;
}
.zone-pill {
    background: #f2f4f7;
    color: #344054;
    border-radius: 999px;
    padding: .35rem .6rem;
    font-weight: 500;
}

.code-box {
    background: #f7f8fa;
    border: 1px solid #eef0f3;
    border-radius: 10px;
    padding: .55rem .75rem;
    font-weight: 600;
    letter-spacing: .3px;
    text-align: center;
    min-height: 38px;
}

.shadow-xs { box-shadow: 0 2px 8px rgba(16,24,40,.06) !important; }
.font-weight-600 { font-weight: 600; }
</style>
